import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    clientName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    AccountExtra1: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' },
        ]
      },
      Theme: {
          validations: [
            { type: 'required', message: 'Please fill in required field.' },
          ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    SiteName: {
      validations: []
    },
    StartTime: {
      validations: []
  }, 
    EndTime: {
      validations: []
    },
    notes: {
        validations: []
      },
      SiteAddress: {
          validations: []
      },
      SiteCity: {
          validations: []
      },
      SiteState: {
          validations: []
      },
      SitePostal: {
          validations: [
              { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
          ]
            },
            EventExtra2: {
                validations: []
              },
              AllergyInfo: {
                  validations: []
      },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company/Organization:',
            mapping: 'clientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
          {
           type: 'text',
           size: 'Medium',
           label: 'Phone:*',
           mapping: 'telNumber'
         }
       ]
     },
     {
      fields: [
          {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Contact Preference:*',
          options: [
              { label: 'Email', value: 'Email' },
              { label: 'Phone', value: 'Phone' },
          ],
          mapping: 'AccountExtra1'
        },
        {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Type of Event:*',
        options: [
            { label: 'Wedding', value: 'Wedding' },
            { label: 'Corporate Event', value: 'Corporate Event' },
            { label: 'Birthday', value: 'Birthday' },
            { label: 'Baby Shower', value: 'Baby Shower' },
            { label: 'Bridal Shower', value: 'Bridal Shower' },
            { label: 'Graduation', value: 'Graduation' },
            { label: 'Memorial', value: 'Memorial' },
            { label: 'Private Party', value: 'Private Party' },
            { label: 'Pick Up', value: 'Pick Up' },
            { label: 'Other', value: 'Other' },
        ],
        mapping: 'Theme'
    }
]
},
{
  fields: [
    {
      type: 'date-picker',
      size: 'Medium',
      label: 'Date of Event:*',
      mapping: 'eventDate'
    },
    {
      type: 'text',
      size: 'Medium',
      label: 'Number of Guests:*',
      mapping: 'plannedguestcount'
    }
  ]
},
{
  fields: [
    {
      type: 'text',
      size: 'Medium',
      label: 'Event Venue:',
      mapping: 'SiteName'
    }
  ]
},
{
  fields: [
    {
      type: 'multiple-choice',
      size: 'Medium',
      label: 'Event Start Time:',
      options: [
        { label: '7:30 AM', value: '07:30:00' },
        { label: '8:00 AM', value: '08:00:00' },
        { label: '8:30 AM', value: '08:30:00' },
        { label: '9:00 AM', value: '09:00:00' },
        { label: '9:30 AM', value: '09:30:00' },
        { label: '10:00 AM', value: '10:00:00' },
        { label: '10:30 AM', value: '10:30:00' },
        { label: '11:00 AM', value: '11:00:00' },
        { label: '11:30 AM', value: '11:30:00' },
        { label: '12:00 PM', value: '12:00:00' },
        { label: '12:30 PM', value: '12:30:00' },
        { label: '1:00 PM', value: '13:00:00' },
        { label: '1:30 PM', value: '13:30:00' },
        { label: '2:00 PM', value: '14:00:00' },
        { label: '2:30 PM', value: '14:30:00' },
        { label: '3:00 PM', value: '15:00:00' },
        { label: '3:30 PM', value: '15:30:00' },
        { label: '4:00 PM', value: '16:00:00' },
        { label: '4:30 PM', value: '16:30:00' },
        { label: '5:00 PM', value: '17:00:00' },
        { label: '5:30 PM', value: '17:30:00' },
        { label: '6:00 PM', value: '18:00:00' },
        { label: '6:30 PM', value: '18:30:00' },
        { label: '7:00 PM', value: '19:00:00' },
        { label: '7:30 PM', value: '19:30:00' },
        { label: '8:00 PM', value: '20:00:00' },
        { label: '8:30 PM', value: '20:30:00' },
        { label: '9:00 PM', value: '21:00:00' },
        { label: '9:30 PM', value: '21:30:00' },
        { label: '10:00 PM', value: '22:00:00' },
        { label: '10:30 PM', value: '22:30:00' },
        { label: '11:00 PM', value: '23:00:00' },
        { label: '11:30 PM', value: '23:30:00' },
      ],
      mapping: 'StartTime'
    },
    {
      type: 'multiple-choice',
      size: 'Medium',
      label: 'Event End Time:',
      options: [
        { label: '7:30 AM', value: '07:30:00' },
        { label: '8:00 AM', value: '08:00:00' },
        { label: '8:30 AM', value: '08:30:00' },
        { label: '9:00 AM', value: '09:00:00' },
        { label: '9:30 AM', value: '09:30:00' },
        { label: '10:00 AM', value: '10:00:00' },
        { label: '10:30 AM', value: '10:30:00' },
        { label: '11:00 AM', value: '11:00:00' },
        { label: '11:30 AM', value: '11:30:00' },
        { label: '12:00 PM', value: '12:00:00' },
        { label: '12:30 PM', value: '12:30:00' },
        { label: '1:00 PM', value: '13:00:00' },
        { label: '1:30 PM', value: '13:30:00' },
        { label: '2:00 PM', value: '14:00:00' },
        { label: '2:30 PM', value: '14:30:00' },
        { label: '3:00 PM', value: '15:00:00' },
        { label: '3:30 PM', value: '15:30:00' },
        { label: '4:00 PM', value: '16:00:00' },
        { label: '4:30 PM', value: '16:30:00' },
        { label: '5:00 PM', value: '17:00:00' },
        { label: '5:30 PM', value: '17:30:00' },
        { label: '6:00 PM', value: '18:00:00' },
        { label: '6:30 PM', value: '18:30:00' },
        { label: '7:00 PM', value: '19:00:00' },
        { label: '7:30 PM', value: '19:30:00' },
        { label: '8:00 PM', value: '20:00:00' },
        { label: '8:30 PM', value: '20:30:00' },
        { label: '9:00 PM', value: '21:00:00' },
        { label: '9:30 PM', value: '21:30:00' },
        { label: '10:00 PM', value: '22:00:00' },
        { label: '10:30 PM', value: '22:30:00' },
        { label: '11:00 PM', value: '23:00:00' },
        { label: '11:30 PM', value: '23:30:00' },
        { label: '12:00 AM (next day)', value: '00:00:00' },
        { label: '12:30 AM (next day)', value: '00:30:00' },
        { label: '1:00 AM (next day)', value: '01:00:00' },
        { label: '1:30 AM (next day)', value: '01:30:00' },
        { label: '2:00 AM (next day)', value: '02:00:00' },
        { label: '2:30 AM (next day)', value: '02:30:00' }
      ],
      mapping: 'EndTime'
    }
  ]
},
{
  fields: [
    {
      type: 'text-area',
      size: 'XLarge',
      label: 'Menu Choices, Details and Additional Information:',
      mapping: 'notes'
    }
  ]
},
        {
          fields: [
              {
              type: 'text',
              size: 'Medium',
              label: 'Venue Address:',
              mapping: 'SiteAddress'
            },
            {
              type: 'text',
              size: 'Medium',
              label: 'Venue City:',
              mapping: 'SiteCity'
          }
      ]
      },
      {
          fields: [
              {
              type: 'text',
              size: 'Medium',
              label: 'Venue State:',
              mapping: 'SiteState'
            },
            {
              type: 'text',
              size: 'Medium',
              label: 'Venue Zipcode:',
              mapping: 'SitePostal'
          }
      ]
      },
      {
        fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'Budget Range:',
            mapping: 'EventExtra2'
          },
          {
          type: 'text',
          size: 'Medium',
          label: 'Are there any allergy concerns or other requirements?:',
          mapping: 'AllergyInfo'
      }
  ]
  },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Sendik\'s Food Markets Contact Form',
    formId: '1836',
    clientKey: '571BC6ED-CF4B-42BB-BA06-003C1B59F9C9',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
